<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-4">
                    <h2>TRADERS TODAY'S BIDS</h2>
                    </div>
                    <div class="col-lg-4 col-8 text-right abs-btn-grp-arbs">
                      <div class="form-group input-group">
                        <div>
                            <span class="input-group-text">IDC Max Count</span>
                        </div>
                        <input v-model="idcMaxCount" class="form-control" type="number">
                        <button :disabled="!idcMaxCount" @click="setIdcMaxCount()" type="button" class="btn btn-success rounded arbs-btn">
                            <i class="fas fa-save"></i>
                            Save
                        </button>
                      </div>   
                    </div>

                    <div class="col-lg-2 col-8 text-right">   
                                         
                        <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                            <i @click="searchTrader()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                            <input v-on:keyup.enter="searchTrader" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search" aria-label="Search">
                            <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form> 
        
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 dashboard" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr >
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'firstName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'firstName'  ? 'sort-desc' : '']"  
                                    @click="sort('firstName')" >TRADER</th>
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'idcPullCount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'idcPullCount'  ? 'sort-desc' : '']"  
                                    @click="sort('idcPullCount')" >IDC COUNT</th> 
                                     
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                     >ASSIGNED COUNT</th> 
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                >total suggested  <span class="hint" data-toggle="tooltip" data-placement="left"  title="The total number of bids suggested for the trader.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i>
              </span> </th> 
                                   
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                >Suggested Price Count <span class="hint" data-toggle="tooltip" data-placement="left"  title="The number of bids sent at the suggested price.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span> </th>   
                <th 
                                    scope="col" 
                                    class="sort text-center"
                                >Bid Count <span class="hint" data-toggle="tooltip" data-placement="left"  title="The total number of bids sent by the trader.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i> </span></th> 
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                >changed Bid Count <span class="hint" data-toggle="tooltip" data-placement="left"  title="The number of bids sent after changing the suggested price.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span></th>   
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                >rejected <span class="hint" data-toggle="tooltip" data-placement="left"  title="The number of suggested bids that are not sent.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span></th>   
                <th 
                                    scope="col" 
                                    class="sort text-center"
                                >executed Bid Count 
                                <span class="hint" data-toggle="tooltip" data-placement="left"  title="The count of executed bids.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span></th>
                <th 
                                    scope="col" 
                                    class="sort text-center"
                                     >FILL RATE <span class="hint" data-toggle="tooltip" data-placement="left"  title="The ratio of traded items to the number of bids sent.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span></th>  
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                >BLACK BOX BIDDING</th>                          
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="totalRows == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="trader in traders" :key="trader.id">
                                <td class="text-center">{{trader.firstName }} {{trader.lastName}}</td>
                                <td class="text-center text-success">{{trader.idcPullCount}}</td>
                                <!-- <td class="text-center">
                                  <div class="input-group">
                                    <input type="number" v-model="trader.idcLimit" class="form-control" placeholder="" aria-label="Text input" aria-describedby="saveIcon">
                                    <div class="input-group-append">
                                      <button class="btn btn-outline-secondary" type="button" id="saveIcon" @click="saveTrader(trader)">
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                </td> -->
                                <td class="text-center">{{trader.bidCountDto.assignedCount}}</td>

                                <td class="text-center">{{trader.bidCountDto.totalSuggestedCount}}</td>
                                <td class="text-center">{{trader.bidCountDto.doneAtSuggestedPriceCount}}</td>
                                <td class="text-center">{{trader.bidCountDto.doneBidCount}}</td>

                                <td class="text-center">{{trader.bidCountDto.changedBidCount}}</td>
                                <td class="text-center">{{trader.bidCountDto.rejected}}</td>
                                <td class="text-center">{{trader.bidCountDto.executedBidCount}}</td>
                                <td class="text-center" >
                                 <span v-if="trader.bidCountDto.doneBidCount"> {{convertToPercentage(trader.bidCountDto.fillRate)}}</span>
                                </td>


                                <td class="text-center">
                                    <toggle-button :sync="true" v-model="trader.blackBoxEnabled" @change="onChangeEventHandler(trader)" style="z-index: 0;"/>
                                </td>
                                
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getTraderList(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
       
    </div>      
</template>
<script>

import config from "@/config";
import authService from "@/authService";
export default {
  name: "imstradersComponent",
  components : {
      
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        sortColumn: "firstName",
        sortOrder: "ASC",
        traderData : null,
        traderEditModalOpen : false,
        traders : [],
        accountList : [],
        isAdmin: false,
        isTrader : false,
        isEditor : false,
        isSuperAdmin : false,
        idcMaxCount : ""
     
    };
  },
  methods: {
    setIdcMaxCount(){
      let dataToSend = [
                          {
                              "setting": "IDC_RATE_LIMIT",
                              "dataType": "NUMERIC",
                              "value": this.idcMaxCount,
                              "updateByCognitoSub" : authService.getUser().cognitoSub
                          }
                      ]
      this.loading = true;
      const auth = {
          headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
          .post(
          config.baseUrlBidSide +
              "/tradebook/setting",dataToSend,
              auth
          )
          .then(() => {
              this.loading = false;
              this.$alert("Saved successfully ","","success")
              this.getTraderList()
          })
          .catch(e => {
              console.log(e);
          });
    },
    getUserSetting(){
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide +
                "/tradebook/setting-list?cognitoSub="+authService.getUser().cognitoSub,
                auth
            )
            .then(result => {
                result.data.forEach(element => {
                  if(element.setting == "IDC_RATE_LIMIT"){
                    this.idcMaxCount = element.value ? element.value : 800;
                  }
                });
                this.idcMaxCount = this.idcMaxCount ? this.idcMaxCount : 800;
            })
            
    },
    onChangeEventHandler(trader){
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let data = [{"userId":trader.id,"blackboxEnabled": trader.blackBoxEnabled}]
      this.$http
        .put(
          config.baseUrlAutoBidder +
            "/autobidder/edit-black-box-enable",data,
          auth
        )
        .then(() => {
          if(trader.blackBoxEnabled){
            this.$alert("Black Box Bidding Enabled.", "", "success");
          }else{
            this.$alert("Black Box Bidding Disabled.", "", "success");
          }
          
        })
        .catch((e) => {
          console.log(e);
        });
    },
    searchTrader(){
        this.getTraderList();
    },
    clearSearch(){
        this.searchValue = "";
        this.getTraderList();
    },
    sort(column){
        this.sortColumn = column;
        this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
        this.getTraderList();
    },
    getTraderList(){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
          config.baseUrlAutoBidder +
            "/autobidder/traders?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=ACTIVE" +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder +
            "&group=Trader"+
            "&startOfDay="+
            this.moment(this.moment().format("MM-DD-YYYY")).utc().format("YYYY-MM-DD HH:mm:ss"),
          auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          this.traders = result.data.content;
          this.loading = false;
        })
    },
  },
  mounted() {
    this.getUserSetting();
    this.getTraderList();
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
        }
    });
  }
};
</script>
<style scoped>
.input-group-append{
  margin-left: 0px;
}
.input-group{
  z-index: 0;
}
</style>